export enum Tutorials {
    JobCreation = "https://vimeo.com/manage/videos/813983130",
    AccountSetup = "https://vimeo.com/manage/videos/813983163",
    SetupCareerPage = "https://vimeo.com/manage/videos/813983155",
    ManageCandidateProfile = "https://vimeo.com/manage/videos/813983167",

    EmailTemplate = "https://vimeo.com/manage/videos/813983188",
    CustomFields = "https://vimeo.com/manage/videos/813983177",
    PrescreenQuestions = "https://vimeo.com/manage/videos/813983152",
    JobTemplate = "https://vimeo.com/manage/videos/813983140"

}
